<template>
	<div>
		
		<!-- confirmation dialog box -->
		<v-dialog v-model="dialog.flag" width="400" >
			<v-card>
				<v-card-title
				class="headline flex-column lighten-2"
				primary-title
				>
				<v-icon size="5rem" color="warning" >
					mdi-help-circle-outline
				</v-icon>
				{{$lang.ARE_YOU_SURE}}?
			</v-card-title >
			<v-card-text class="flex-column text-center mb-5 ">
				{{$lang.ARE_YOU_SURE_DELETE}}  this Image?
			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions class="text-center">
				<v-spacer></v-spacer>
				<v-btn color="light" width="80" class="fw-bold" @click="dialog.flag=false">	
					No 
				</v-btn>	
				<v-btn color="primary" width="80" class="fw-bold ml-5" :loading="dialog.btn_loading"  @click="deleteImage">	
					Yes
				</v-btn>	
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>
<script>
export default{
	props:['dialog','deleteImage'],
	data(){
		return{
			btn_loading:false,
		}
	},
	methods:{
		
	}
}

</script>